import { forwardRef } from 'react';

/**
 * A shimmering placeholder for content that hasn't loaded yet (spec §7.2).
 * Purely decorative — pair it with a live-region status message elsewhere
 * (e.g. on the container using it) rather than relying on the skeleton
 * itself to announce loading.
 *
 * @param {object} props
 * @param {'text'|'circle'|'rect'} [props.shape='rect']
 * @param {string|number} [props.width]
 * @param {string|number} [props.height]
 * @param {string} [props.className]
 */
export const Skeleton = forwardRef(function Skeleton({ shape = 'rect', width, height, className = '', style, ...rest }, ref) {
  return (
    <div
      ref={ref}
      className={`etch-skeleton ${className}`.trim()}
      data-shape={shape}
      aria-hidden="true"
      style={{ width, height, ...style }}
      {...rest}
    />
  );
});

export default Skeleton;
